// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-details-container {
  padding: 2%;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.header-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2%;
}

.header-title {
  display: flex;
  align-content: flex-start;
  font-size: x-large;
  font-weight: bold;
  margin: 1% 0 5% 0;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 1%;
  padding: 0;
}

.search-container label {
  font-size: medium;
  width: 40%;
}

.search-box {
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 0;
  background-color: white;
  width: 100%;
  height: 100%;
}

.ed-search-input {
  border: none;
  outline: none;
  font-size: medium;
  color: #333;
  height: 40px;
  width: 100%;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.ed-search-input::placeholder {
  padding: 0 0 0 2%;
  color: #999;
  font-size: 13px;
}

.calendar-input-group {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: nowrap;
}

.calendar-label {
  font-size: medium;
  color: #333;
  white-space: nowrap;
  margin: 0;
}

.calendar-input-wrapper {
  display: flex;
  align-items: center;
  height: 40px;
}

.custom-calendar-input {
  display: flex;
  align-items: center;
  position: relative;
  margin: 0;
}

.custom-calendar-input input {
  width: 90px;
  padding: 0px 30px 0px 10px;
  margin: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: medium;
  height: 40px;
}

.custom-calendar-input .calendar-icon {
  position: absolute;
  right: 10px;
  color: #888;
  cursor: pointer;
}

.emp-search-text {
  display: flex;
  padding:7px 10px;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: larger;
  border-radius: 5px;
  background-color: #79c42b;
  color: white;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.emp-search-text:hover {
  background-color: #68a822; /* Slightly darker shade */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.emp-search-text:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.emp-search-text:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.ed-search-icon {
  margin-right: 5px;
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  width: 15%;
}

.add-employee-button {
  display: flex;
  align-items: center;
  padding: 0 3%;
  background-color: #79c42b;
  color: #ffffff;
  font-size: larger;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.add-employee-button:hover {
  background-color: #68a822; /* Slightly darker shade */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.add-employee-button:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.add-employee-button:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.add-employee-button .add-icon {
  font-size: 30px;
  margin-right: 5px;
}

.employee-table-container {
  width: 100%;
  height: 520px;
  overflow-y: auto;
  overflow-x: auto;
  margin: 2% 0;
  padding: 0;
  border: 1px solid #ddd;
}

.employee-table {
  width: 100%;
  border-collapse: collapse;
}

.employee-table th {
  top: 0;
  border: 2px solid #cccbce;
  background-color: #f2f2f2;
  padding: 1% 0;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.employee-table td {
  border: 1px solid #cccbce;
  background-color: #fff;
  padding: 0.5%;
  text-align: left;
  font-size: 14px;
}

.employee-table tr {
  background-color: #fff;
}

.employee-table th:nth-child(3),
.employee-table td:nth-child(3) {
  min-width: 90px;
  text-align: center;
}

.employee-table td:nth-child(9) {
  min-width: 75px;
  text-align: right;
}

.status-active {
  color: #029d02;
  font-weight: bold;
}

.status-inactive {
  color: red;
  font-weight: bold;
}

.edit:disabled,
.deactivate:disabled {
  color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Container for action buttons */
.actions {
  display: flex;
  justify-content: space-around;
}

/* Common styles for both edit and deactivate buttons */
button.edit,
button.deactivate {
  padding: 0;
  cursor: pointer;
  font-size: x-large;
  border: none;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

/* Edit button specific styles */
button.edit {
  background-color: #fff;
  color: #000000;
}

button.edit:hover {
  background-color: #e6e6e6; /* Slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

button.edit:active {
  transform: scale(0.98);
}

/* Deactivate button specific styles */
button.deactivate {
  background-color: #fff;
  color: #000000;
}

button.deactivate:hover {
  background-color: #e6e6e6; /* Slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

button.deactivate:active {
  transform: scale(0.98);
}

/* Optional: Focus styles for accessibility */
button.edit:focus,
button.deactivate:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.employee-form {
  display: flex;
  flex-direction: column;
  gap: 2%;
  background-color: #e8e9ea;
  border-radius: 0%;
  padding: 0%;
  width: 100%;
  height: auto;
  box-sizing: border-box;
}

.form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #00468c;
  height: 5vh;
  padding: 1% 5% 1% 3%;
}

.form-header-title {
  font-size: 1.5vw;
  color: #ffffff;
}

.cancel-icon {
  font-size: 2vw;
  color: #ffffff;
  cursor: pointer;
}

.form-grid {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(4, minmax(20%, 1fr));
  gap: 2%;
  padding: 2%;
}

.form-group {
  margin-bottom: 10%;
}

.form-group label {
  padding: 0%;
  margin: 0 0 0 5%;
}

.form-grid input {
  margin: 0 0 0 5%;
  padding: 3%;
  border: 1px solid #cccbce;
  border-radius: 5px;
  width: 76%;
  background-color: #ffffff;
}

.form-grid select {
  margin: 0 0 0 5%;
  padding: 3%;
  border: 1px solid #cccbce;
  border-radius: 5px;
  width: 84%;
  background-color: #ffffff;
}

.required {
  color: red;
}

.button-group {
  display: flex;
  gap: 10%;
  justify-content: flex-end;
  padding: 2% 4% 1% 1%;
}

.cancel-button {
  background-color: transparent;
  color: #000000;
  border: 0.3vw solid #7fbd2c;
  width: 25%;
  padding: 1%;
  cursor: pointer;
  font-size: 1vw;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease, border-color 0.3s ease;
}

.save-employee-button {
  background-color: #7fbd2c;
  color: white;
  border: none;
  width: 25%;
  padding: 1%;
  cursor: pointer;
  font-size: 1vw;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

/* Hover states */
.cancel-button:hover {
  background-color: rgba(127, 189, 44, 0.1); /* subtle background change */
  border-color: #68a822; /* slightly darker border */
}

.save-employee-button:hover {
  background-color: #68a822; /* slightly darker shade */
}

/* Active states (pressed effect) */
.cancel-button:active,
.save-employee-button:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

/* Focus states for accessibility */
.cancel-button:focus,
.save-employee-button:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.emp-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.emp-modal {
  background-color: #e8e9ea;
  padding: 0;
  width: 70%;
  position: relative;
}

.delete-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delete-modal {
  background-color: #e8e9ea;
  border: 10px solid #00468c;
  padding: 1.5%;
  width: 30%;
  top: 6%;
  position: relative;
  text-align: center;
}

.delete-buttons {
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding: 2%;
}

.delete-modal-cancel {
  background-color: transparent;
  color: #000000;
  border: 0.3vw solid #7fbd2c;
  width: 25%;
  padding: 1%;
  cursor: pointer;
  font-size: 1vw;
}

.delete-modal-delete {
  background-color: #7fbd2c;
  color: white;
  border: none;
  width: 25%;
  padding: 1%;
  cursor: pointer;
  font-size: 1vw;
}

.modal-delete-button:hover {
  background-color: #999;
}

.errors {
  font-size: medium;
  color: red;
  margin: 0.5% 2%;
}

.radio-group {
  margin: 0 3%;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmployeeDetails/EmployeeDetails.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,MAAM;EACN,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA,uDAAuD;AACvD;;EAEE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB;wBACsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kDAAkD;EAClD,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,eAAe;EACf,cAAc;EACd;gDAC8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,WAAW;EACX,eAAe;EACf,cAAc;EACd;wBACsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,yCAAyC,EAAE,6BAA6B;EACxE,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,mCAAmC;AACnC;;EAEE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,mCAAmC;AACnC;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,UAAU;EACV,OAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".employee-details-container {\n  padding: 2%;\n  margin: 0;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.header-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 2%;\n}\n\n.header-title {\n  display: flex;\n  align-content: flex-start;\n  font-size: x-large;\n  font-weight: bold;\n  margin: 1% 0 5% 0;\n}\n\n.search-container {\n  display: flex;\n  align-items: center;\n  gap: 1%;\n  padding: 0;\n}\n\n.search-container label {\n  font-size: medium;\n  width: 40%;\n}\n\n.search-box {\n  display: flex;\n  align-items: center;\n  border-radius: 5px;\n  padding: 0;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n}\n\n.ed-search-input {\n  border: none;\n  outline: none;\n  font-size: medium;\n  color: #333;\n  height: 40px;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n}\n\n.ed-search-input::placeholder {\n  padding: 0 0 0 2%;\n  color: #999;\n  font-size: 13px;\n}\n\n.calendar-input-group {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-wrap: nowrap;\n}\n\n.calendar-label {\n  font-size: medium;\n  color: #333;\n  white-space: nowrap;\n  margin: 0;\n}\n\n.calendar-input-wrapper {\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.custom-calendar-input {\n  display: flex;\n  align-items: center;\n  position: relative;\n  margin: 0;\n}\n\n.custom-calendar-input input {\n  width: 90px;\n  padding: 0px 30px 0px 10px;\n  margin: 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: medium;\n  height: 40px;\n}\n\n.custom-calendar-input .calendar-icon {\n  position: absolute;\n  right: 10px;\n  color: #888;\n  cursor: pointer;\n}\n\n.emp-search-text {\n  display: flex;\n  padding:7px 10px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  font-size: larger;\n  border-radius: 5px;\n  background-color: #79c42b;\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.emp-search-text:hover {\n  background-color: #68a822; /* Slightly darker shade */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.emp-search-text:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.emp-search-text:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.ed-search-icon {\n  margin-right: 5px;\n}\n\n.actions-container {\n  display: flex;\n  justify-content: flex-end;\n  width: 15%;\n}\n\n.add-employee-button {\n  display: flex;\n  align-items: center;\n  padding: 0 3%;\n  background-color: #79c42b;\n  color: #ffffff;\n  font-size: larger;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.add-employee-button:hover {\n  background-color: #68a822; /* Slightly darker shade */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.add-employee-button:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.add-employee-button:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.add-employee-button .add-icon {\n  font-size: 30px;\n  margin-right: 5px;\n}\n\n.employee-table-container {\n  width: 100%;\n  height: 520px;\n  overflow-y: auto;\n  overflow-x: auto;\n  margin: 2% 0;\n  padding: 0;\n  border: 1px solid #ddd;\n}\n\n.employee-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.employee-table th {\n  top: 0;\n  border: 2px solid #cccbce;\n  background-color: #f2f2f2;\n  padding: 1% 0;\n  font-weight: bold;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.employee-table td {\n  border: 1px solid #cccbce;\n  background-color: #fff;\n  padding: 0.5%;\n  text-align: left;\n  font-size: 14px;\n}\n\n.employee-table tr {\n  background-color: #fff;\n}\n\n.employee-table th:nth-child(3),\n.employee-table td:nth-child(3) {\n  min-width: 90px;\n  text-align: center;\n}\n\n.employee-table td:nth-child(9) {\n  min-width: 75px;\n  text-align: right;\n}\n\n.status-active {\n  color: #029d02;\n  font-weight: bold;\n}\n\n.status-inactive {\n  color: red;\n  font-weight: bold;\n}\n\n.edit:disabled,\n.deactivate:disabled {\n  color: #ccc;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Container for action buttons */\n.actions {\n  display: flex;\n  justify-content: space-around;\n}\n\n/* Common styles for both edit and deactivate buttons */\nbutton.edit,\nbutton.deactivate {\n  padding: 0;\n  cursor: pointer;\n  font-size: x-large;\n  border: none;\n  border-radius: 5px;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n/* Edit button specific styles */\nbutton.edit {\n  background-color: #fff;\n  color: #000000;\n}\n\nbutton.edit:hover {\n  background-color: #e6e6e6; /* Slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\nbutton.edit:active {\n  transform: scale(0.98);\n}\n\n/* Deactivate button specific styles */\nbutton.deactivate {\n  background-color: #fff;\n  color: #000000;\n}\n\nbutton.deactivate:hover {\n  background-color: #e6e6e6; /* Slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\nbutton.deactivate:active {\n  transform: scale(0.98);\n}\n\n/* Optional: Focus styles for accessibility */\nbutton.edit:focus,\nbutton.deactivate:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.employee-form {\n  display: flex;\n  flex-direction: column;\n  gap: 2%;\n  background-color: #e8e9ea;\n  border-radius: 0%;\n  padding: 0%;\n  width: 100%;\n  height: auto;\n  box-sizing: border-box;\n}\n\n.form-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #00468c;\n  height: 5vh;\n  padding: 1% 5% 1% 3%;\n}\n\n.form-header-title {\n  font-size: 1.5vw;\n  color: #ffffff;\n}\n\n.cancel-icon {\n  font-size: 2vw;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.form-grid {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(4, minmax(20%, 1fr));\n  gap: 2%;\n  padding: 2%;\n}\n\n.form-group {\n  margin-bottom: 10%;\n}\n\n.form-group label {\n  padding: 0%;\n  margin: 0 0 0 5%;\n}\n\n.form-grid input {\n  margin: 0 0 0 5%;\n  padding: 3%;\n  border: 1px solid #cccbce;\n  border-radius: 5px;\n  width: 76%;\n  background-color: #ffffff;\n}\n\n.form-grid select {\n  margin: 0 0 0 5%;\n  padding: 3%;\n  border: 1px solid #cccbce;\n  border-radius: 5px;\n  width: 84%;\n  background-color: #ffffff;\n}\n\n.required {\n  color: red;\n}\n\n.button-group {\n  display: flex;\n  gap: 10%;\n  justify-content: flex-end;\n  padding: 2% 4% 1% 1%;\n}\n\n.cancel-button {\n  background-color: transparent;\n  color: #000000;\n  border: 0.3vw solid #7fbd2c;\n  width: 25%;\n  padding: 1%;\n  cursor: pointer;\n  font-size: 1vw;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.save-employee-button {\n  background-color: #7fbd2c;\n  color: white;\n  border: none;\n  width: 25%;\n  padding: 1%;\n  cursor: pointer;\n  font-size: 1vw;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n/* Hover states */\n.cancel-button:hover {\n  background-color: rgba(127, 189, 44, 0.1); /* subtle background change */\n  border-color: #68a822; /* slightly darker border */\n}\n\n.save-employee-button:hover {\n  background-color: #68a822; /* slightly darker shade */\n}\n\n/* Active states (pressed effect) */\n.cancel-button:active,\n.save-employee-button:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n/* Focus states for accessibility */\n.cancel-button:focus,\n.save-employee-button:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.emp-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.emp-modal {\n  background-color: #e8e9ea;\n  padding: 0;\n  width: 70%;\n  position: relative;\n}\n\n.delete-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.delete-modal {\n  background-color: #e8e9ea;\n  border: 10px solid #00468c;\n  padding: 1.5%;\n  width: 30%;\n  top: 6%;\n  position: relative;\n  text-align: center;\n}\n\n.delete-buttons {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  padding: 2%;\n}\n\n.delete-modal-cancel {\n  background-color: transparent;\n  color: #000000;\n  border: 0.3vw solid #7fbd2c;\n  width: 25%;\n  padding: 1%;\n  cursor: pointer;\n  font-size: 1vw;\n}\n\n.delete-modal-delete {\n  background-color: #7fbd2c;\n  color: white;\n  border: none;\n  width: 25%;\n  padding: 1%;\n  cursor: pointer;\n  font-size: 1vw;\n}\n\n.modal-delete-button:hover {\n  background-color: #999;\n}\n\n.errors {\n  font-size: medium;\n  color: red;\n  margin: 0.5% 2%;\n}\n\n.radio-group {\n  margin: 0 3%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
